import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import circleAIBotAvatar from "../assets/icons/CircleAIBot-avatar.png";
import aiIcon from "../assets/icons/ai-icon.png";
import demoUser from "../assets/icons/demo-user.png";
import handWave from "../assets/icons/hand-wave-24.png";
import ActionButton from "../components/common/ActionButton";
import HelpInputArea from "../components/common/HelpInputArea";

const HomePage = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const history = useHistory();

  const handleHelpSubmit = (text: string) => {
    // TODO: Handle help text submission
    void text; // Temporary to avoid unused parameter warning
  };

  const onActionButtonClick = (type: "chat" | "feedback" | "report_bug") => {
    if (type === "chat" || type === "feedback") {
      history.push("/chat");
    } else if (type === "report_bug") {
      history.push("/report_bug_form");
    }
  };

  return (
    <div className="flex h-full min-h-[600px] flex-col items-center justify-end">
      <div className="flex w-full max-w-[480px] flex-col items-center px-4 pb-6">
        {/* Icons row */}
        <div className="relative flex h-16 justify-center">
          {/* AI Icon Left */}
          <div className="absolute left-[calc(50%-56px)] top-1/2 z-0 flex h-10 w-10 -translate-y-1/2 items-center justify-center">
            <img
              src={aiIcon}
              alt={t("support_widget_v2.home_page.ai_icon_alt")}
              className="h-full w-full object-contain"
              loading="eager"
            />
          </div>

          {/* Circle AI Bot Avatar */}
          <div className="z-10 flex h-16 w-16 items-center justify-center">
            <img
              src={circleAIBotAvatar}
              alt={t("support_widget_v2.home_page.circle_ai_bot_alt")}
              className="h-full w-full object-contain"
              loading="eager"
            />
          </div>

          {/* Demo User Icon */}
          <div className="absolute right-[calc(50%-56px)] top-1/2 z-0 flex h-10 w-10 -translate-y-1/2 items-center justify-center">
            <img
              src={demoUser}
              alt={t("support_widget_v2.home_page.demo_user_alt")}
              className="h-full w-full object-contain"
              loading="eager"
            />
          </div>
        </div>

        {/* Greeting */}
        <div className="mt-4 flex items-center gap-2 text-center">
          <div className="text-primary-900">
            <Typography.TitleLg>
              {t("support_widget_v2.home_page.greeting", {
                first_name:
                  currentCommunityMember?.first_name ||
                  t("support_widget_v2.home_page.default_greeting_name"),
              })}
            </Typography.TitleLg>
          </div>
          <img
            src={handWave}
            alt={t("support_widget_v2.home_page.wave_icon_alt")}
            className="h-6 w-6"
            loading="eager"
          />
        </div>
        <div className="mt-2">
          <Typography.BodyMd color="rgba(84,88,97,1)">
            {t("support_widget_v2.home_page.help_text")}
          </Typography.BodyMd>
        </div>

        <div className="mt-6 flex w-full flex-col items-center gap-3">
          <div className="flex w-full justify-center gap-3">
            <ActionButton
              iconName="sw-question"
              text={t("support_widget_v2.home_page.ask_question")}
              onClick={() => onActionButtonClick("chat")}
            />
            <ActionButton
              iconName="sw-report-bug"
              text={t("support_widget_v2.home_page.report_bug")}
              onClick={() => onActionButtonClick("report_bug")}
            />
          </div>
          <ActionButton
            iconName="sw-feedback"
            text={t("support_widget_v2.home_page.give_feedback")}
            onClick={() => onActionButtonClick("feedback")}
          />
        </div>

        <div className="mt-[68px] w-full">
          <HelpInputArea
            onSubmit={handleHelpSubmit}
            placeholder={t(
              "support_widget_v2.home_page.help_input_placeholder",
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
